import { oc } from "@orpc/contract";
import { z } from "zod";
import { ForecastApprovalKeySchema } from "./forecast-approvals.contract";

export const ForecastNoteSchema = z.object({
  id: z.string().uuid(),
  warehouseId: z.string().uuid(),
  productV3Key: z.string(),
  body: z.string(),
  createdByUserId: z.string().uuid(),
  createdByUserName: z.string().nullable(),
  createdAt: z.string(),
});

export type ForecastNote = z.infer<typeof ForecastNoteSchema>;
export type ForecastNoteKey = z.infer<typeof ForecastApprovalKeySchema>;

export const ListForecastNotesInputSchema = ForecastApprovalKeySchema.extend({
  limit: z.int().min(1).max(200).prefault(200),
  offset: z.int().min(0).prefault(0),
});
export const ListForecastNotesResponseSchema = z.object({
  notes: z.array(ForecastNoteSchema),
  pagination: z.object({
    total: z.number().int().nonnegative(),
    hasMore: z.boolean(),
  }),
});

export const CreateForecastNoteInputSchema = ForecastApprovalKeySchema.extend({
  body: z.string().trim().min(1).max(50_000),
});

export const DeleteForecastNoteInputSchema = z.object({
  id: z.string().uuid(),
});

export const forecastNotesContracts = {
  list: oc
    .input(ListForecastNotesInputSchema)
    .output(ListForecastNotesResponseSchema)
    .route({
      method: "GET",
      summary: "List forecast notes for a SKU",
      description:
        "Returns paged notes left on a SKU's forecast at a warehouse, with author and timestamp.",
    }),
  create: oc
    .input(CreateForecastNoteInputSchema)
    .output(ForecastNoteSchema)
    .route({
      method: "POST",
      summary: "Add a note to a SKU forecast",
      description:
        "Adds a text note by the current user to a SKU's forecast at a warehouse.",
    }),
  delete: oc
    .input(DeleteForecastNoteInputSchema)
    .output(z.object({ success: z.literal(true) }))
    .route({
      method: "DELETE",
      summary: "Delete a forecast note",
      description:
        "Deletes a forecast note by id. Only the note's author can delete it.",
    }),
} as const;
